<template>
  <div class="commentlist">
    <van-nav-bar fixed title="商品评价" left-text="返回" left-arrow @click-left="$router.back()" />

    <template v-if="comments.length > 0">
      <div class="comment-header">
        全部评价（<span class="total">{{ total }}</span>条）
      </div>

      <div class="comment-list">
        <div class="comment-item" v-for="item in comments" :key="item.comment_id">
          <div class="top">
            <img :src="item.user.avatar_url || localavatar" alt="" />
            <div class="name">{{ item.user.nick_name }}</div>
            <van-rate :size="14" :value="item.score" readonly />
          </div>
          <div class="content">{{ item.content }}</div>
          <div class="time">{{ item.create_time }}</div>
        </div>
      </div>

      <!-- 加载更多 -->
      <div class="load-more" v-if="!loading">
        <div v-if="hasMore" class="load-btn" @click="loadMore">加载更多</div>
        <div v-else class="load-end">— 已经到底啦 —</div>
      </div>
      <div class="load-more" v-else>
        <van-loading size="18" color="#ff6b35">加载中...</van-loading>
      </div>
    </template>

    <!-- 暂无评价 -->
    <div v-else-if="!loading" class="empty-state">
      <van-icon name="comment-o" size="60" color="#ccc" />
      <p>暂时还没有评价</p>
    </div>

    <div class="bottom-placeholder"></div>
  </div>
</template>

<script>
import { getGoodsCommentsApi } from '@/api/product'

export default {
  name: 'CommentList',
  data () {
    return {
      goodsId: '',
      comments: [],
      total: 0,
      page: 1,
      pageSize: 10,
      hasMore: false,
      loading: false,
      localavatar: require('@/assets/default-avatar.svg')
    }
  },
  created () {
    this.goodsId = this.$route.query.goodsId
    this.getList(true)
  },
  methods: {
    async getList (reset = false) {
      if (!this.goodsId) return
      if (this.loading) return
      this.loading = true
      try {
        const { data } = await getGoodsCommentsApi({
          goodsId: this.goodsId,
          limit: this.pageSize,
          page: this.page
        })
        this.total = data.total
        this.hasMore = data.has_more
        this.comments = reset ? (data.list || []) : this.comments.concat(data.list || [])
      } catch (err) {
        // 请求失败时展示空态而非白屏，错误信息由 request.js 统一提示
        if (reset) {
          this.comments = []
          this.total = 0
          this.hasMore = false
        }
      } finally {
        this.loading = false
      }
    },
    loadMore () {
      this.page += 1
      this.getList(false)
    }
  }
}
</script>

<style lang="less" scoped>
.commentlist {
  min-height: 100vh;
  background: #f6f6f6;
  padding-top: 46px; // 给固定导航栏留空间

  /deep/ .van-nav-bar__arrow { color: #333; }
  /deep/ .van-nav-bar__text { color: #333; }
  /deep/ .van-nav-bar { z-index: 100; }

  .comment-header {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
    background: #fff;

    .total {
      color: #ff6b35;
      font-weight: 600;
    }
  }

  .comment-list {
    background: #fff;
    margin-top: 6px;

    .comment-item {
      padding: 14px;
      font-size: 14px;
      line-height: 22px;
      border-bottom: 1px solid #f5f5f5;

      .top {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        img {
          width: 22px;
          height: 22px;
          border-radius: 50%;
          object-fit: cover;
        }

        .name {
          margin: 0 10px;
          flex: 1;
          color: #333;
        }
      }

      .content {
        color: #555;
        word-break: break-all;
      }

      .time {
        margin-top: 6px;
        font-size: 12px;
        color: #999;
      }
    }
  }

  .load-more {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 18px 0;
    font-size: 14px;
    color: #999;

    .load-btn {
      color: #ff6b35;
      cursor: pointer;
      padding: 4px 24px;

      &:active {
        opacity: 0.7;
      }
    }
  }

  // 暂无评价空态
  .empty-state {
    text-align: center;
    padding: 120px 20px;

    p {
      color: #999;
      margin-top: 12px;
    }
  }

  .bottom-placeholder {
    height: 20px;
  }
}
</style>
